import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { updateNotesFilters } from "../../redux/siteMonitoring/noteActions";
import { formatNoteStatus } from "../../redux/siteMonitoring/siteMonitoringStatusActions";
import { clone, distinct } from "../../utils";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	FormControl,
	FormControlLabel,
	InputLabel,
	MenuItem,
} from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ALL_SELECT_OPTION } from "../../constants";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import CustomizedSelect from "../Input/CustomizedSelect";

class SiteMonitoringNotesFilters extends Component {
	state = {};

	onLotChange(e) {
		let newFilters = clone(this.props.notesFilters);
		newFilters.lotId = e.target.value;
		this.props.updateNotesFilters(newFilters, this.props.notes, this.props.activeUser);
	}

	onAssignedUserChange(e) {
		let newFilters = clone(this.props.notesFilters);
		newFilters.assignedUser = e.target.value;
		this.props.updateNotesFilters(newFilters, this.props.notes, this.props.activeUser);
	}

	onCreatorUserChange(e) {
		let newFilters = clone(this.props.notesFilters);
		newFilters.creatorId = e.target.value;
		this.props.updateNotesFilters(newFilters, this.props.notes, this.props.activeUser);
	}

	onStatesChange(e) {
		let newFilters = clone(this.props.notesFilters);
		newFilters.status = e.target.value;
		this.props.updateNotesFilters(newFilters, this.props.notes, this.props.activeUser);
	}

	onTagsChange(e) {
		let newFilters = clone(this.props.notesFilters);
		newFilters.tags = e.target.value;
		this.props.updateNotesFilters(newFilters, this.props.notes, this.props.activeUser);
	}

	onDateChange(date) {
		let newFilters = clone(this.props.notesFilters);
		newFilters.limitDate = date;
		this.props.updateNotesFilters(newFilters, this.props.notes, this.props.activeUser);
	}

	render() {
		let allElement = (
			<MenuItem key={0} value={ALL_SELECT_OPTION}>
				{"Tous"}
			</MenuItem>
		);

		let lotElements = [allElement];
		let assignedUserElements = [allElement];
		let creatorUserElements = [allElement];
		let stateElements = [allElement];
		let tagElements = [allElement];

		this.props.notes
			.map((n) => n.lot_id)
			.filter(distinct)
			.map((lotId) => {
				let lot = this.props.lots.find((l) => l.id === lotId);

				if (!lot) return;

				lotElements.push(
					<MenuItem key={lot.id} value={lot.id}>
						{lot.name}
					</MenuItem>
				);
			});

		this.props.notes
			.map((n) => n.assigned_user_id)
			.filter(distinct)
			.map((userId) => {
				let assignedUser = this.props.siteMonitoring.site_supervision_authorized_user_ids
					.map((au) => au.user_id)
					.find((u) => u ? u.id === userId : false);

				if (!assignedUser) return;

				assignedUserElements.push(
					<MenuItem key={userId} value={userId}>
						{assignedUser.name}
					</MenuItem>
				);
			});

		this.props.notes
			.map((n) => n.create_uid)
			.filter((create_uid) => create_uid)
			.filter((create_uid, index, self) => distinct(create_uid.id, index, self.map(u => u.id)))
			.map((create_uid) =>
				creatorUserElements.push(
					<MenuItem key={create_uid.id} value={create_uid.id}>
						{create_uid.name}
					</MenuItem>
				)
			);

		this.props.notes
			.map((n) => n.state)
			.filter(distinct)
			.map((state) =>
				stateElements.push(
					<MenuItem key={state} value={state}>
						{formatNoteStatus(state)}
					</MenuItem>
				)
			);

		let tagIds = [];

		this.props.notes.forEach((n) => {
			tagIds = tagIds.concat(n.category_ids);
		});

		tagIds = tagIds.filter(distinct);

		tagIds.map((tagId) => {
			let associatedTag = this.props.tags.find((t) => t.id === tagId);

			if (!associatedTag) return;

			tagElements.push(
				<MenuItem key={associatedTag.id} value={associatedTag.id}>
					{associatedTag.name}
				</MenuItem>
			);
		});

		return (
			<Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin without-side-padding filters-card">
				<CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
					<Accordion className="col-lg-12 col-md-12 col-sm-12 col-12 filters-card">
						<AccordionSummary className="without-side-padding " expandIcon={<ExpandMoreIcon />}>
							<FormControlLabel
								aria-label="Acknowledge"
								className="col-lg-12 col-md-12 col-sm-12 col-12"
								onClick={(event) => event.stopPropagation()}
								onFocus={(event) => event.stopPropagation()}
								control={
									<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
										<FormControl className="col-lg-3 col-md-4 col-sm-6 col-12  control-padding-right-padding">
											<InputLabel htmlFor="assigned-user">{"Assigné à"}</InputLabel>
											<CustomizedSelect
												id="assigned-user"
												name="assigned-user"
												value={this.props.notesFilters.assignedUser}
												onChange={this.onAssignedUserChange.bind(this)}
											>
												{assignedUserElements}
											</CustomizedSelect>
										</FormControl>

										<FormControl className="col-lg-3 col-md-4 col-sm-6 col-12  control-padding-right-padding">
											<InputLabel htmlFor="state">{"Statut"}</InputLabel>
											<CustomizedSelect
												id="state"
												name="state"
												multiple
												value={this.props.notesFilters.status}
												onChange={this.onStatesChange.bind(this)}
											>
												{stateElements}
											</CustomizedSelect>
										</FormControl>
									</div>
								}
							/>
						</AccordionSummary>
						<AccordionDetails className="without-padding expandable-div-padding-bottom">
							<FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
								<InputLabel htmlFor="lot">{"Lot"}</InputLabel>
								<CustomizedSelect
									id="lot"
									name="lot"
									value={this.props.notesFilters.lotId}
									onChange={this.onLotChange.bind(this)}
								>
									{lotElements}
								</CustomizedSelect>
							</FormControl>
							<FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
								<InputLabel htmlFor="creator">{"Créateur"}</InputLabel>
								<CustomizedSelect
									id="creator"
									name="creator"
									value={this.props.notesFilters.creatorId}
									onChange={this.onCreatorUserChange.bind(this)}
								>
									{creatorUserElements}
								</CustomizedSelect>
							</FormControl>
							<FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
								<InputLabel htmlFor="tags">{"Étiquettes"}</InputLabel>
								<CustomizedSelect
									id="tags"
									name="tags"
									multiple
									value={this.props.notesFilters.tags}
									onChange={this.onTagsChange.bind(this)}
								>
									{tagElements}
								</CustomizedSelect>
							</FormControl>
							<FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
								<MuiPickersUtilsProvider
									locale={"fr"}
									utils={MomentUtils}
									moment={moment}
								>
									<DatePicker
										name="limit-date-filter"
										value={this.props.notesFilters.limitDate}
										onChange={this.onDateChange.bind(this)}
										label="Date limite d'exécution"
										emptyLabel=""
										invalidDateMessage="La date est invalide"
										invalidLabel="La date est invalide"
										clearLabel="Effacer"
										cancelLabel="Annuler"
										format="DD/MM/YYYY"
										className="full_size"
										clearable
									/>
								</MuiPickersUtilsProvider>
							</FormControl>
						</AccordionDetails>
					</Accordion>
				</CardContent>
			</Card>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		notes: state.notes.notes,
		notesFilters: state.notes.notesFilters,
		lots: state.siteMonitoring.lots,
		tags: state.tags.allTags,
		siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
		activeUser: state.activeUser,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateNotesFilters: (filters, notes, activeUser) => dispatch(updateNotesFilters(filters, notes, activeUser)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SiteMonitoringNotesFilters);
